import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useData } from "../lib/data";

function rank(recipes, q) {
  return recipes.map(r => {
    let sc = 0; const t = r.title.toLowerCase();
    if (t.startsWith(q)) sc += 4; else if (t.includes(q)) sc += 3;
    if (r.tags.some(g => g.toLowerCase().includes(q))) sc += 2;
    if (r.ingredients.some(i => i.name.toLowerCase().includes(q))) sc += 1;
    return [sc, r];
  }).filter(x => x[0] > 0).sort((a, b) => b[0] - a[0] || a[1].price - b[1].price).slice(0, 6);
}

export function SearchForm({ hero = false }) {
  const data = useData();
  const nav = useNavigate();
  const form = useRef(null);
  const [val, setVal] = useState("");
  const [on, setOn] = useState(false);
  const q = val.trim().toLowerCase();
  const open = () => setOn(q.length >= 2);

  useEffect(() => { setOn(val.trim().length >= 2); }, [val]);
  useEffect(() => {
    const h = e => { if (form.current && !form.current.contains(e.target)) setOn(false); };
    document.addEventListener("click", h);
    return () => document.removeEventListener("click", h);
  }, []);

  const res = on && data ? rank(data.recipes, q) : [];
  const submit = e => { e.preventDefault(); setOn(false); nav(`/opskrifter/?q=${encodeURIComponent(val)}`); };
  const pick = e => { if (e.target.closest("a")) { setOn(false); setVal(""); } };
  const id = hero ? "hero-q" : "hq";
  const tid = hero ? "hero-search" : "header-search";

  const box = (
    <div className={"sr" + (on ? " on" : "")} role={hero ? undefined : "listbox"} data-testid={`${tid}-suggestions`} onClick={pick}>
      {on && (res.length
        ? <>{res.map(([, r]) => (
            <a key={r.slug} href={`/opskrifter/${r.slug}/`} data-testid={`${tid}-suggestion-${r.slug}`}>
              <span className="e">{r.emoji}</span><span><b>{r.title}</b><small>{r.time} min og ca. {r.price} kr. pr. person</small></span>
            </a>))}
            <a className="all" href={`/opskrifter/?q=${encodeURIComponent(val.trim())}`} data-testid={`${tid}-all`}>Se alle resultater</a></>
        : <p className="none" data-testid={`${tid}-none`}>Ingen opskrifter fundet. Prøv fx “kylling” eller “pasta”.</p>)}
    </div>
  );
  const input = (
    <input id={id} name="q" type="search" placeholder={hero ? "Søg fx kylling eller pasta" : "Søg opskrift"} autoComplete="off"
      value={val} onChange={e => setVal(e.target.value)} onFocus={open} data-testid={`${tid}-input`}
      onKeyDown={e => { if (e.key === "Escape") setOn(false); }} />
  );
  if (hero) return (
    <form action="/opskrifter/" method="get" role="search" data-search="" ref={form} onSubmit={submit}>
      <label className="vh" htmlFor={id}>Søg opskrift</label>{input}
      <button className="btn" type="submit" data-testid="hero-search-submit">Søg</button>{box}
    </form>
  );
  return (
    <form className="hs" role="search" action="/opskrifter/" method="get" data-search="" ref={form} onSubmit={submit}>
      <label className="vh" htmlFor={id}>Søg opskrift</label>{input}{box}
    </form>
  );
}
